import { render, staticRenderFns } from "./ModalHistoricoUsuario.vue?vue&type=template&id=7de1e29a&"
import script from "./ModalHistoricoUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports